import React, { useCallback, useContext, useState } from 'react';
import { Button } from 'antd';

import DocumentsContext from '@totem/components/documents/report/documentsContext';
import { DocumentReference } from '@totem/components/documents/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DOCUMENTS_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';
type Props = {
  onClose: (refresh: boolean) => void;
  reference: DocumentReference;
};
const DocumentLinkSubmitButton = ({ onClose, reference }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const { loading, selectedDocuments } = useContext(DocumentsContext);
  const [isSending, setIsSending] = useState(false);
  const sendDocumentLink = useCallback(
    async (ref: DocumentReference, documentIds: string[]) => {
      if (!isSending) {
        const payload = {
          reference: ref.objectReference,
          documentIds,
        };

        fetch(`${DOCUMENTS_ENDPOINT}/link`, {
          method: 'POST',
          headers: new Headers({
            Authorization: `Bearer ${getApiToken()}`,
          }),
          body: JSON.stringify(payload),
        }).then((res) => {
          setIsSending(false);
          const success = CheckResponseShowError(res);
          if (success) {
            onClose(true);
          }
        });
      }
    }, // End async
    [],
  );
  const handleSubmit = () => {
    const documentIDs = selectedDocuments.map((item) => item.document.id);
    sendDocumentLink(reference, documentIDs);
  };
  return (
    <Button
      type="primary"
      onClick={handleSubmit}
      disabled={loading || isSending}
    >
      Save
    </Button>
  );
};
export default DocumentLinkSubmitButton;
